import { getEnvValue } from '../../config/env';
import type { ApplicationInsights, IEventTelemetry } from '@microsoft/applicationinsights-web';

type Properties = IEventTelemetry['properties'];

export const Logger = class {
  private static appInsights: ApplicationInsights | null = null;
  private static initialization: Promise<void> | null = null;

  /**
   * Both the SDK download and its start-up used to happen as a side effect of this module being
   * evaluated, i.e. inside the main bundle's evaluation, before React rendered anything. The SDK is
   * a monolithic bundle, so it is now fetched on demand and started after first paint; the tracking
   * calls below already tolerate not being initialized yet.
   */
  public static initialize(): Promise<void> {
    if (Logger.initialization) {
      return Logger.initialization;
    }

    const connectionString = getEnvValue('APP_INSIGHTS_CONNECTION_STRING');
    if (!connectionString) {
      Logger.initialization = Promise.resolve();
      return Logger.initialization;
    }

    Logger.initialization = import('@microsoft/applicationinsights-web').then(({ ApplicationInsights }) => {
      Logger.appInsights = new ApplicationInsights({
        config: {
          connectionString,
        },
      });
      Logger.appInsights.loadAppInsights();
    });

    return Logger.initialization;
  }

  public static trackException(exception: Error) {
    Logger.appInsights?.trackException({ exception });
  }

  public static logEvent(name: string, properties?: Properties) {
    Logger.appInsights?.trackEvent({ name, properties });
  }
};
